import { useSyncExternalStore } from 'react';

/**
 * Whether the global <Navigation /> is hidden on phones. The trip planner
 * sets it for as long as it is mounted (trial, 2026-09-24): on a phone the
 * planner's own header carries the LYF logo as the way home, and the site
 * nav's 65px goes to the itinerary instead. Desktop is never affected — the
 * nav applies it as `max-md:hidden`.
 *
 * A module-level store because the nav and the page are siblings under
 * App.js with no shared parent state, and a context would re-render the
 * whole route tree. Whoever sets it MUST clear it on unmount; nothing else
 * will, and every other page would lose its nav.
 */
let hidden = false;
const listeners = new Set();

export function setSiteNavHidden(next) {
  if (hidden === !!next) return;
  hidden = !!next;
  listeners.forEach((fn) => fn());
}

function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function useSiteNavHidden() {
  return useSyncExternalStore(subscribe, () => hidden, () => false);
}
